import { Box, Group, Text, UnstyledButton } from "@mantine/core";

import classes from "./ChartFilterChip.module.css";

import type { FC } from "react";

export type ChartFilterChipProps = {
  color?: string;
  label: string;
  onClick: () => void;
  selected: boolean;
};

export const ChartFilterChip: FC<ChartFilterChipProps> = ({ color, label, onClick, selected }) => {
  return (
    <UnstyledButton
      className={`${classes.chip} ${selected ? classes.chipSelected : ""}`}
      onClick={onClick}
    >
      <Group gap={8} wrap="nowrap">
        {color && <Box className={classes.dot} style={{ backgroundColor: color }} />}
        <Text className={classes.label} size="sm">
          {label}
        </Text>
      </Group>
    </UnstyledButton>
  );
};
